var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPersonSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5531 13.6449L10.6011 9.69343C11.31 8.75485 11.6365 7.58224 11.5146 6.41232C11.3926 5.2424 10.8314 4.16232 9.94409 3.39011C9.05681 2.61791 7.90959 2.2111 6.73404 2.25181C5.55849 2.29252 4.44217 2.77772 3.61043 3.60946C2.7787 4.44119 2.2935 5.55752 2.25279 6.73307C2.21207 7.90862 2.61889 9.05583 3.39109 9.94312C4.1633 10.8304 5.24338 11.3917 6.4133 11.5136C7.58321 11.6355 8.75582 11.3091 9.6944 10.6001L13.6459 14.5521C13.7661 14.6723 13.9292 14.7399 14.0992 14.7399C14.2692 14.7399 14.4323 14.6723 14.5525 14.5521C14.6728 14.4319 14.7403 14.2688 14.7403 14.0988C14.7403 13.9287 14.6728 13.7657 14.5525 13.6454L14.5531 13.6449ZM3.54027 6.89769C3.54027 6.23315 3.73733 5.58353 4.10653 5.03098C4.47573 4.47843 5.00049 4.04777 5.61445 3.79346C6.22841 3.53915 6.904 3.47261 7.55577 3.60225C8.20755 3.7319 8.80624 4.05191 9.27615 4.52181C9.74605 4.99172 10.0661 5.59041 10.1957 6.24219C10.3254 6.89397 10.2588 7.56955 10.0045 8.18351C9.75019 8.79747 9.31953 9.32223 8.76699 9.69143C8.21444 10.0606 7.56481 10.2577 6.90027 10.2577C6.00944 10.2567 5.15539 9.90239 4.52548 9.27248C3.89557 8.64257 3.54126 7.78852 3.54027 6.89769Z",
    fill: "#689802"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.90991,
    cy: 5.65921,
    rx: 0.974359,
    ry: 1.03226,
    fill: "#689802"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91116 6.89844C5.74994 6.89844 4.80859 7.82275 4.80859 8.96295H9.01372C9.01372 7.82275 8.07237 6.89844 6.91116 6.89844Z",
    fill: "#689802"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersonSearch);
export default __webpack_public_path__ + "static/media/icon-person-search.056c4df80be46113a50d914a31183fb6.svg";
export { ForwardRef as ReactComponent };